<template>
  <div class="tabs">
    <slot />
  </div>
</template>